/* eslint-disable */
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

/**
 * EmptyState component for the Urban Dashboard.
 *
 * Displayed when the Counts API returns success but all metric values are zero or null.
 * Replaces only the metrics grid area while maintaining the page layout and header.
 *
 * Validates: Requirements 6.1, 6.2, 6.3, 8.4
 */
function EmptyState() {
    return (
        <section aria-label="Empty dashboard state: no transaction data available" style={{ width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 320,
                    py: { xs: 6, sm: 8 },
                    px: 3,
                    border: '1px solid rgba(15, 23, 42, 0.06)',
                    borderRadius: '12px',
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)'
                }}
            >
                {/* Modern design icon container */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 52,
                        height: 52,
                        borderRadius: '12px',
                        backgroundColor: '#EEF2F6', // Soft slate
                        color: 'primary.main',
                        mb: 2.5,
                        border: '1px solid rgba(79, 70, 229, 0.05)'
                    }}
                    aria-hidden="true"
                >
                    <AssessmentOutlinedIcon sx={{ fontSize: '24px' }} />
                </Box>

                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'text.primary',
                        mb: 1,
                        letterSpacing: '-0.01em',
                        textAlign: 'center'
                    }}
                >
                    No transaction metrics yet
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '13.5px',
                        textAlign: 'center',
                        maxWidth: 380,
                        lineHeight: 1.55
                    }}
                >
                    Metrics will appear here automatically once your active merchants begin initiating transactions.
                </Typography>
            </Box>
        </section>
    );
}

export default EmptyState;
